import React from "react"
import PropTypes from "prop-types"

import Prompt from "shared/components/Prompt"

const NotificationUser = () => {
  return (
    <Prompt iconName="Info" hiddenButtons centerText>
      Estamos atualizando o Portal para melhorar sua experiência! O acesso e os
      autosserviços continuam disponíveis.
    </Prompt>
  )
}

NotificationUser.propTypes = {
  customer: PropTypes.object,
  contacts: PropTypes.array,
  lastUpdate: PropTypes.object,
  history: PropTypes.object,
  t: PropTypes.func
}

export default NotificationUser



// WEBPACK FOOTER //
// ./src/components/Masthead/components/NotificationUser.js